import * as clamp from 'lodash/clamp'
import { Component } from 'react'
import * as styles from 'styles/unorganized/RateComparison.css'
import ChartTooltip from 'components/atoms/ChartTooltip'
import { toPercent } from 'helpers/formatHelpers'
import { AccountTyped, RateComparison as RateComparisonType } from 'interfaces/accounts'
import AbsentValue from 'components/atoms/AbsentValue'

const TOOLTIP_COLOR = '#4651a2'

type RateComparisonProps = RateComparisonType & AccountTyped

// TODO @pmyagkov need to redo the markup; it's unsupportable, absolute positioning everywhere
class RateComparison extends Component<RateComparisonProps> {

  render () {
    const { effective_rate, overall_bounds } = this.props

    if (effective_rate === null || overall_bounds === null) {
      return <AbsentValue>N/A</AbsentValue>
    }

    const { lower: totalMin, upper: totalMax } = overall_bounds

    const scale = 100 / (totalMax - totalMin)
    const effectiveRateDiff = clamp(effective_rate, totalMin, totalMax) - totalMin
    const userRateLeft = effectiveRateDiff * scale


    return (
      <div className={ styles.rateComparisonWrapper }>
        <div className={ styles.rateComparison }>
          { this.renderGreenStripe() }
          <div
            className={ styles.userRate }
            style={{
              left: toPercent(userRateLeft),
            }}
          />
          <div
            className={ styles.userRateTooltip }
            style={{
              left: toPercent(userRateLeft),
            }}
          >
            <ChartTooltip color={ TOOLTIP_COLOR }>
              { effective_rate }%
            </ChartTooltip>
          </div>
          <span className={ styles.totalMin }>{ totalMin }%</span>
          <span className={ styles.totalMax }>{ totalMax }%</span>
        </div>
      </div>
    )
  }

  renderGreenStripe = () => {
    const { fair_bounds, overall_bounds } = this.props
    if (fair_bounds === null || overall_bounds === null) {
      return null
    }

    const { lower: totalMin, upper: totalMax } = overall_bounds
    const { lower: greenMin, upper: greenMax } = fair_bounds

    const scale = 100 / (totalMax - totalMin)

    const greenLeft = (greenMin - totalMin) * scale
    const greenRight = (totalMax - greenMax) * scale

    return (
      <div
        className={ styles.green }
        style={{
          left: toPercent(greenLeft),
          right: toPercent(greenRight),
        }}
      />
    )
  }
}

export default RateComparison
